import { render, staticRenderFns } from "./platCharge.vue?vue&type=template&id=548d6f83&scoped=true"
import script from "./platCharge.vue?vue&type=script&lang=js"
export * from "./platCharge.vue?vue&type=script&lang=js"
import style0 from "./platCharge.vue?vue&type=style&index=0&id=548d6f83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548d6f83",
  null
  
)

export default component.exports